import { atom, selector, selectorFamily } from 'recoil'
import { recentlyViewedClient } from 'src/clients'
import { RecentlyViewedRequest, UserList } from 'src/common-services/types/user-lists-types'
import { authData } from 'src/components/auth/util'
import { keyFactory } from 'src/utils/recoil'

const key = keyFactory('recently-viewed')

export const lastSaveDate = atom<Date>({
  key: key('last-save-date'),
  default: new Date(),
})

export const recentViews = selector<UserList | undefined>({
  key: key('recent-views'),
  get: async ({ get }) => {
    const _authData = get(authData)
    if (!_authData) {
      return undefined
    }
    return get(recentlyViewed({ types: ['location', 'place', 'custom-area'] }))
  },
})

export const recentOwnerViews = selector<UserList | undefined>({
  key: key('recent-owner-views'),
  get: async ({ get }) => {
    const _authData = get(authData)
    if (!_authData) {
      return undefined
    }
    return get(recentlyViewed({ types: ['owner'] }))
  },
})

export const recentPlaceViews = selector<UserList | undefined>({
  key: key('recent-place-views'),
  get: async ({ get }) => {
    const _authData = get(authData)
    if (!_authData) {
      return undefined
    }
    return get(recentlyViewed({ types: ['location', 'parcel', 'place'] }))
  },
})

export const recentlyViewed = selectorFamily<UserList | undefined, RecentlyViewedRequest | undefined>({
  key: key('recently-viewed'),
  get:
    (request) =>
    async ({ get }) => {
      // refresh on save
      get(lastSaveDate)
      return recentlyViewedClient.getRecentlyViewed(request)
    },
})
